// extracted by mini-css-extract-plugin
export var avatar = "W_5";
export var sm = "W_cj";
export var selected = "W_d2";
export var rotate = "W_c";
export var dotty = "W_d";